var _path, _path2, _ellipse, _ellipse2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserRedeemPoints = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.527301 16.7209H1.5819C1.87311 16.7209 2.1092 16.4866 2.1092 16.1975V10.4397H0.527301C0.23609 10.4397 0 10.6741 0 10.9632V16.1975C0 16.4865 0.23609 16.7209 0.527301 16.7209Z",
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0689 1C8.84588 1 7.04382 2.78884 7.04382 4.99555C7.04382 7.20219 8.84588 8.9911 11.0689 8.9911C13.2919 8.9911 15.094 7.20219 15.094 4.99555C15.094 2.78884 13.2919 1 11.0689 1Z",
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.069,
    cy: 4.99556,
    rx: 3.0188,
    ry: 2.99666,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0689,
    cy: 4.99605,
    rx: 2.31442,
    ry: 2.29744,
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51959 17.0006H9.63559C11.4073 16.9796 13.1052 16.4806 14.6028 15.5803L17.5451 13.5389C18.0407 13.1934 18.1357 12.5444 17.8088 12.0838C17.4713 11.6022 16.8174 11.4871 16.3429 11.8221L13.5165 13.7902C12.6096 14.3136 11.5023 14.4287 10.5004 14.0937L7.24868 13.0259C6.97448 12.9422 6.8268 12.6385 6.92175 12.3664C7.00608 12.1047 7.28028 11.9581 7.55448 12.0314C7.56502 12.0314 11.2069 13.2039 11.2069 13.2039C11.8202 13.3864 12.3651 13.0419 12.5357 12.5339C12.715 11.979 12.4092 11.3928 11.8608 11.2149L6.90062 9.60269C5.81572 9.21064 4.35373 9.29163 3.16382 9.95214V15.8119L7.30137 16.7423C8.05931 16.9078 8.80302 17.0006 9.51959 17.0006V17.0006Z",
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserRedeemPoints, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-redeem-points.21ba8865.svg";
export { ForwardRef as ReactComponent };